
export default
{
	version: "0.2.7",
};
